<ng-container>
	<header [class.scrolled]="isScrolled">
		<lib-page-header [menuEntries]="menuEntries"
						[subMenuEntries]="subMenuEntries"
						[isEtrackerInitialized]="isEtrackerInitialized"
		></lib-page-header>
	</header>
	<main>
		<router-outlet/>
	</main>
	<footer>
		<lib-page-footer/>
	</footer>
</ng-container>





